import React, { useRef, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Row, Col, Input, ConfigProvider, Button } from 'antd'
import { formatMessageNew } from '@/utils/common'
import { modalSuccess, modalError, destroyModal, modalConfirm } from '@/utils/modalUtils'
import { validateOrUnbindOrderByCarton, unbindingByOrder } from '@/services/qrCode/unbind'
let errorModal = null
let successModal = null
let errorNum = 0
const QrCodeUnbindByCartonPage = () => {
  const history = useHistory()
  const cartonInputRef = useRef(null)
  const macState = useSelector(state => state.commonStore.mac)
  const deviceCode = useSelector(state => state.commonStore.deviceCode)
  const [cartonNoValue, setCartonNoValue] = useState('')
  const [inputReadOnly, setInputReadOnly] = useState(false)
  const queryHeader = {
    isRF: true,
    mac: macState,
    deviceCode,
    operator: deviceCode
  }
  // 页面初始化
  useEffect(() => {
    cartonInputRef.current.focus({ cursor: 'all' })
    // 监听全局键盘事件
    window.addEventListener('keydown', onWindowKeyDown)
    window.addEventListener('keyup', onWindowKeyUp)
    return () => {
      // 移除全局键盘事件
      window.removeEventListener('keydown', onWindowKeyDown)
      window.removeEventListener('keyup', onWindowKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // // 弹出 输入框要失焦点，防止再次触发回车事件
  // useEffect(() => {
  //   if (errorModal || successModal) {
  //     cartonInputRef.current.blur()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [errorModal, successModal])
  // 全局键盘事件
  const onWindowKeyDown = e => {
    console.log('onWindowKeyDown', e.keyCode)
    if (e.keyCode === 13) {
    }
  }
  // 全局键盘事件
  const onWindowKeyUp = e => {
    console.log('e.onWindowKeyUp', e.keyCode)
    if (e.keyCode === 13) {
      // 关闭 错误提示弹窗
      if (errorModal) {
        destroyModal(errorModal)
        cartonInputRef.current.focus({ cursor: 'all' })
        errorModal = null
        errorNum = 0
      }
      // 关闭 成功提示弹窗
      if (successModal) {
        destroyModal(successModal)
        cartonInputRef.current.focus({ cursor: 'all' })
        successModal = null
        errorNum = 0
      }
    }
  }

  const onInputChange = e => {
    const value = e.target.value.trim()
    const index = value.indexOf('/n')
    const newValue = index > -1 ? value.substring(0, index) : value
    setCartonNoValue(newValue)
  }

  const onInputKeyDown = e => {
    if (e.keyCode === 13) {
      validateOrUnbindOrderByCartonFun()
    }
  }
  const onInputFocus = e => {
    setInputReadOnly(true)
    setTimeout(() => {
      setInputReadOnly(false)
    }, 100)
  }
  const validateOrUnbindOrderByCartonFun = () => {
    if (!macState) {
      if (errorNum === 0) {
        errorNum = 1
        cartonInputRef.current.blur()
        errorModal = modalError(
          {
            content: formatMessageNew('languageObj.nsptagLocale.rfMacError')
          },
          () => {
            cartonInputRef.current.focus({ cursor: 'all' })
            errorNum = 0
          }
        )
      }
      return
    }
    if (!cartonNoValue) {
      return
    }
    let params = {
      type: 1,
      cartonNumber: cartonNoValue
    }
    validateOrUnbindOrderByCarton(params, queryHeader)
      .then(res => {
        if (res.resultData) {
          let strList = res.resultData.split('\n')
          let str = strList.map((item, index) => {
            return <div key={index}>{item}</div>
          })
          modalConfirm(
            {
              content: str,
              onCancel: () => {
                cartonInputRef.current.focus({ cursor: 'all' })
              }
            },
            () => {
              unbindingFun()
            }
          )
        } else {
          if (errorNum === 0) {
            errorNum = 1
            cartonInputRef.current.blur()
            successModal = modalSuccess(
              {
                title: formatMessageNew('languageObj.qrCode.unbindByCartonSuccess'),
                content: (
                  <div className="fwb">
                    {formatMessageNew('languageObj.qrCode.cartonNo')}: {cartonNoValue}
                  </div>
                )
              },
              () => {
                cartonInputRef.current.focus({ cursor: 'all' })
                errorNum = 0
              }
            )
          }
        }
      })
      .catch(err => {
        if (errorNum === 0) {
          errorNum = 1
          cartonInputRef.current.blur()
          errorModal = modalError(
            {
              content: formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
  }
  const unbindingFun = () => {
    let params = {
      type: 1,
      cartonNumber: cartonNoValue
    }
    unbindingByOrder(params, queryHeader)
      .then(() => {
        if (errorNum === 0) {
          errorNum = 1
          cartonInputRef.current.blur()
          successModal = modalSuccess(
            {
              title: formatMessageNew('languageObj.qrCode.unbindByCartonSuccess'),
              content: (
                <div className="fwb">
                  {formatMessageNew('languageObj.qrCode.cartonNo')}: {cartonNoValue}
                </div>
              )
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
      .catch(err => {
        if (errorNum === 0) {
          errorNum = 1
          cartonInputRef.current.blur()
          errorModal = modalError(
            {
              content: formatMessageNew('languageObj.qrCode.errorcode_' + err.errorCode)
            },
            () => {
              cartonInputRef.current.focus({ cursor: 'all' })
              errorNum = 0
            }
          )
        }
      })
  }
  const backFirstPage = () => {
    history.push('/rf/login')
  }
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 14
        }
      }}
    >
      <div className="h100">
        <Row align="middle">
          <Col span={8}>{formatMessageNew('languageObj.qrCode.cartonNo')}：</Col>
          <Col span={16}>
            <Input
              className="pt5 pb5"
              ref={cartonInputRef}
              value={cartonNoValue}
              allowClear
              readOnly={inputReadOnly}
              placeholder={`${formatMessageNew('languageObj.nsptagLocale.pleaseScan')}${formatMessageNew(
                'languageObj.qrCode.cartonNo'
              )}`}
              onFocus={onInputFocus}
              onKeyDown={onInputKeyDown}
              onChange={onInputChange}
            />
          </Col>
        </Row>
        <div className="position-fixed-btn">
          <Button type="primary" className="phone-btn2 reset-btn mt0" onClick={backFirstPage}>
            {`${formatMessageNew('languageObj.qrCode.backFirstPage')}`}
          </Button>
        </div>
      </div>
    </ConfigProvider>
  )
}
export default QrCodeUnbindByCartonPage
